import styled from 'styled-components'

interface IStyleProps {
  color?: string
  isNewCard: boolean
}

export const Card = styled.div`
  background: #fdfdfd;
  min-height: 90px;
  max-height: ${(props: IStyleProps) => {
    if (props.isNewCard) return '130px'
    return '90px'
  }};
  width: 315px;
  gap: 6px;
  box-shadow: 0px 3px 4px rgba(0, 0, 0, 0.25);
  border-radius: 5px;
  padding: ${(props: IStyleProps) => {
    if (props.isNewCard) return '30px 42px 20px 30px'
    return '39px 42px 20px 30px'
  }};
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  position: relative;
  margin-bottom: 10px;

  .first-row {
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  p {
    margin: 0;
  }

  .error-message {
    font-size: 13px;
    line-height: 12px;
    color: red;
  }

  textarea {
    background: #fdfdfd;
    border: none;
    resize: none;
    outline: none;
    font-size: 12px;
    line-height: 14px;
    ::-webkit-scrollbar {
      width: 8px;
      background-color: #c4c4c4;
      border-radius: 50px;
    }
    ::-webkit-scrollbar-track {
      background: #fbfbfb;
      border: 0;
    }
    ::-webkit-scrollbar-thumb {
      width: 8px;
      background-color: #c4c4c4;
      border-radius: 50px;
    }
  }

  .big-date {
    z-index: 211;
    font-weight: 300;
    font-size: 22px;
    margin-left: 30px;
    color: black;
    position: absolute;
  }

  .small-hour {
    z-index: 211;
    font-weight: 300;
    font-size: 10px;
    color: black;
  }

  .bold {
    font-style: normal;
    font-weight: 700;
    font-size: 16px;
    line-height: 12px;
    color: #070707;
  }

  .light {
    color: #9c948c;
    font-size: 14px;
    line-height: 20px;
  }

  .ball-icon {
    height: 10px;
    width: 10px;
    border-radius: 50%;
    color: red;
    margin-right: 10px;
  }

  .send {
    font-weight: 700;
    font-size: 12px;
    line-height: 18px;
    color: #0bf569;
    width: 34px;
    height: 18px;
    margin-left: 25px;
    border: none;
    background: #fdfdfd;
    padding: none;
  }
`
